import axios from 'axios';
import { serverUrl,apiUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const POST_LIKE_PROCESS_LOADING = 'POST_PROCESS_LOADING'
export const POST_LIKE_UPDATED = 'POST_LIKE_UPDATED'
export const POST_LIKE_PROCESS_FAILED = 'POST__LIKE_PROCESS_FAILED'
export const POST_LIKE_LOADED = 'POST_LIKE_LOADED'

export const POST_COMMENT_PROCESS_LOADING = 'POST_COMMENT_PROCESS_LOADING'
export const POST_COMMENT_LOADED = 'POST_COMMENT_LOADED'
export const POST_COMMENT_PROCESS_FAILED = 'POST_COMMENT_PROCESS_FAILED'


export const likePost = (reflectionId, isLiked) => {
    return (dispatch, getState) => {
        // dispatch({ type: POST_LIKE_PROCESS_LOADING })
        
        return axios.post(
            serverUrl.ReflectionPost + '/like', 
            { reflection_id: reflectionId, like: isLiked }
        ).then(resp => {
            if (resp.status === 200) {
                // let newIsLiked = resp.data.like
                dispatch({ 
                    type: POST_LIKE_UPDATED,
                    
                })
                dispatch(getLikes(reflectionId))
                
            }

        }).catch((err) => {
            tokenAuthorize(err?.response?.status)
            dispatch({ 
                type: POST_LIKE_PROCESS_FAILED, errors: [err]
            })
            console.log(err)
        })
    }
}

export const getLikes = (reflectionId) => {
    return (dispatch, getState) => {
        // dispatch({ type: POST_PROCESS_LOADING })

        return axios.get(
            apiUrl + 'likes/' + reflectionId
        ).then(resp => {
            if (resp.status === 200) {
                let likesList = resp.data.results
                dispatch({
                    type: POST_LIKE_LOADED, 
                    data: {
                        likesList,
                    }
                });
                // dispatch(getShowcases());
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status)
            dispatch({ 
                type: POST_LIKE_PROCESS_FAILED, errors: [err]
            })
            console.log(err)
        })
    }
}

export const getComments = (reflectionId) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_COMMENT_PROCESS_LOADING })

        return axios.get(
            apiUrl + 'comments/' + reflectionId
        ).then(resp => {
            if (resp.status === 200) {
                let commentList = resp.data.results
                
                dispatch({
                    type: POST_COMMENT_LOADED, 
                    data: {
                        commentList,
                    }
                });
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status)
            dispatch({ 
                type: POST_COMMENT_PROCESS_FAILED, errors: [err]
            })
            console.log(err)
        })
    }
}
